import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { CarrierReportService } from '../../services/carrier-report.service';
import { EmployeeService } from '../../services/employee.service';
import { ProductionOrderService } from '../../services/production-order.service';
import { AuthService } from '../../services/auth.service';

import { Utils } from '../../util';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-create-carrier-report',
    templateUrl: './create-carrier-report.component.html',
    styleUrls: ['./create-carrier-report.component.css', '../../app.component.css']
})

export class CreateCarrierReportComponent implements OnInit, OnDestroy {

    reportForm: FormGroup;
    report: any;

    carriers = {};
    carrierInit: any;
    carrierText = '';

    projects = {};
    projectInit: any;
    projectText = '';

    pickadateParams = Utils.pickadateParams();
    pickatimeParams = Utils.pickatimeParams();

    geSubs: Subscription;
    gpoSubs: Subscription;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private carrierReportService: CarrierReportService,
                private employeeService: EmployeeService,
                private productionOrderService: ProductionOrderService,
                private authService: AuthService) {
        this.loadCarriersAndProjects();
    }

    ngOnInit() {
        this.reportForm = this.formBuilder.group({
            carrier: ['', Validators.required],
            project: ['', Validators.required],
            reportDate: ['', Validators.required],
            startTime: ['', Validators.required],
            endTime: ['', [Validators.required]]
        });
    }

    onSubmitReport() {
        this.report = this.saveReport();

        this.carrierReportService.postCarrierReport(this.report).then(res => {
            this.reportForm.reset();

            this.router.navigate(['/edt_carrier_report/', res]);
        });
    }

    saveReport() {
        const reportDate = Utils.convertDatefromISOStringtoObject(this.reportForm.get('reportDate').value);
        const currentDate = new Date();
        const userSession = this.authService.currentUser;

        const reportJson = {
            active: 1,
            createdAt: currentDate,
            employeeId: this.carriers[this.reportForm.get('carrier').value],
            endTime: this.reportForm.get('endTime').value,
            productionOrderId: this.projects[this.reportForm.get('project').value],
            reportDate:  reportDate,
            startTime: this.reportForm.get('startTime').value,
            updatedAt: currentDate,
            captureUser: userSession['email']
        };

        return reportJson;
    }

    loadCarriersAndProjects() {
        this.geSubs = this.employeeService.getEmployees().subscribe(tempCarriers => {
            const dataEmployee = {};

            for (const idx in tempCarriers) {
                let employeeDisplayValue = `${tempCarriers[idx].name} ${tempCarriers[idx].lastName} (${tempCarriers[idx].internalKey})`;
                dataEmployee[employeeDisplayValue] = null;
                this.carriers[employeeDisplayValue] = tempCarriers[idx].id$;
            }

            this.carrierInit = {
                'data': dataEmployee,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.carriers[val]);
                }
            };
        });

        this.gpoSubs = this.productionOrderService.getProductionOrders().subscribe(tempProjects => {
            const dataProject = {};

            for (const idx in tempProjects) {
                dataProject[tempProjects[idx].name] = null;
                this.projects[tempProjects[idx].name] = tempProjects[idx].id$;
            }

            this.projectInit = {
                'data': dataProject,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.projects[val]);
                }
            };
        });
    }

    onBlurCarrier() {
        if (this.carriers[this.carrierText] === undefined) {
            this.carrierText = '';
        }
    }

    onBlurProject() {
        if (this.projects[this.projectText] === undefined) {
            this.projectText = '';
        }
    }

    ngOnDestroy() {
        this.geSubs.unsubscribe();
        this.gpoSubs.unsubscribe();
    }

}
